import {
    ROOT,
    GET_PRODUCE_MASTER,
    GET_PRICE_PRODUCE_MASTER_RATE,
    GET_ROOM_RATE_WITH_FORMULA,
    SAVE_FORMULA_ITEM_MASTER_RATE,
    GET_ALL_ROOM_RATE_WITH_FORMULA,
    REMOVE_FORMULA_ITEM,
    GET_ROOM_RATE_WITH_FORMULA_DATE,
    UPDATE_ROOM_RATE_FORMULA_DATE,
    GET_ROOM_RATE_DERIVATIONS_DENOMINATOR_LIST,
    GET_ROOM_RATE_LIST_FORMULA
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getProduceMaster() {
    return fetch(ROOT + GET_PRODUCE_MASTER, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getPriceProduce(body) {
    return fetch(ROOT + GET_PRICE_PRODUCE_MASTER_RATE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getRoomRateWithFormula() {
    return fetch(ROOT + GET_ROOM_RATE_WITH_FORMULA, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function saveFormulaItem(body) {
    return fetch(ROOT + SAVE_FORMULA_ITEM_MASTER_RATE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getAllRoomRateMasterRate() {
    return fetch(ROOT + GET_ALL_ROOM_RATE_WITH_FORMULA, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function removeFormula(body) {
    return fetch(ROOT + REMOVE_FORMULA_ITEM + `/${body}`, requestOptions.get(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getRoomRateWithFormulaDate(body) {
    return fetch(ROOT + GET_ROOM_RATE_WITH_FORMULA_DATE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateRoomRateFormulaDate(body) {
    return fetch(ROOT + UPDATE_ROOM_RATE_FORMULA_DATE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getRoomRateDerivationsDenominatorList() {
    return fetch(ROOT + GET_ROOM_RATE_DERIVATIONS_DENOMINATOR_LIST, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getRoomRateListFormula(body) {
    return fetch(ROOT + GET_ROOM_RATE_LIST_FORMULA, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
//#endregion
export const masterRateService = {
    getProduceMaster,
    getPriceProduce,
    getRoomRateWithFormula,
    saveFormulaItem,
    getAllRoomRateMasterRate,
    removeFormula,
    getRoomRateWithFormulaDate,
    updateRoomRateFormulaDate,
    getRoomRateDerivationsDenominatorList,
    getRoomRateListFormula
}